import { CzechSuklRsAtcGroupResponse } from 'com.cogvio.pricemonitor.api';

export function buildSuklCodesFromGroups(groups: CzechSuklRsAtcGroupResponse[]): Array<{ codes: string[] }> {
	return groups
		.flatMap((group) => group.products)
		.map((product) => ({
			codes: product.productVersions.map((version) => version.suklCode).filter((code): code is string => Boolean(code)),
		}))
		.filter(({ codes }) => codes.length > 0);
}
